import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import styles from './index.css';

const Result = ({ score }) => {
    let years = '';

    if (score <= 204 && score >= 121) {
        years = 70;
    } else if (score <= 120 && score >= 61) {
        years = 80;
    } else if (score <= 60 && score >= 21) {
        years = 90;
    } else if (score <= 20) {
        years = 0;
    }

    useEffect(() => {
        pageStatistics({
            behavior: 'page',
            type: 'wdcwjy_wbt',
            ref: 'other',
            id: 'wdcwjy_wbid',
        });
    }, []);

    return (
        <div className={styles.wrap}>
            {years === 70 && (
                <img
                    className={styles.wrapPic}
                    src="https://x0.ifengimg.com/ucms/2023_03/81832F1E861BBCC2ECA629B0279D4E9328528211_size425_w1125_h2001.jpg"
                />
            )}
            {years === 80 && (
                <img
                    className={styles.wrapPic}
                    src="https://x0.ifengimg.com/ucms/2023_03/AF3842D9391DEBE272EEBF1FDD7FFCCB9BE69EE9_size423_w1125_h2001.jpg"
                />
            )}
            {years === 90 && (
                <img
                    className={styles.wrapPic}
                    src="https://x0.ifengimg.com/ucms/2023_03/AB855C3D8E50B48B80E17298EDE64FCBCB38A336_size423_w1125_h2001.jpg"
                />
            )}
            {years === 0 && (
                <img
                    className={styles.wrapPic}
                    src="https://x0.ifengimg.com/ucms/2023_03/C7493E1E9630CA5D9BD74B8DF9A7E848E57D7311_size411_w1125_h2001.jpg"
                />
            )}
            <div className={styles.wrapText}>● 长按保存图片并分享</div>
        </div>
    );
};

Result.propTypes = {
    score: PropTypes.number,
};

export default errorBoundary(Result);
